import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIconNext = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 18, viewBox: "0 0 10 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1.49805L8.5 8.99805L1 16.498", stroke: "#525A68", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgIconNext);
const Memo = memo(ForwardRef);
export default Memo;
